module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/credit@2x-bedd2512f4e2c006d6d3fb9b689a613c.png";